<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">

    <a-form :form="form">

      <a-form-item
        label="用户名"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户名，此为必填项" v-decorator="[ 'user_name' , {rules: [{ required: true}]} ]"/>
      </a-form-item>

      <a-form-item
        label="用户昵称"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户昵称，非必填项" v-decorator="[ 'user_nickname']"/>
      </a-form-item>

      <a-form-item
        label="手机"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户手机，非必填项" v-decorator="[ 'user_mobile']"/>
      </a-form-item>

      <a-form-item
        label="QQ"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户QQ，非必填项" v-decorator="[ 'user_qq']"/>
      </a-form-item>

      <a-form-item
        label="邮箱"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户邮箱，非必填项" v-decorator="[ 'user_mail']"/>
      </a-form-item>

      <a-form-item
        label="备注信息"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="请输入用户备注信息，非必填项" v-decorator="[ 'user_comments']"/>
      </a-form-item>

      <a-form-item
        label="用户角色"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <a-select placeholder="请选择用户角色，非必填项" v-decorator="['role_id']">
          <a-select-option value="0">测试用户</a-select-option>
          <a-select-option value="1">管理员</a-select-option>
          <a-select-option value="2">普通用户</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        :wrapperCol="{ span: 22 }"
        style="text-align: center"
      >

        <a-button htmlType="submit" type="primary" @click="handleSubmit">提交</a-button>

      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import SelectHospital from '@/components/selector/SelectHospital'
import { addData } from '@/api/data'
import { getUserList, updateUserInfo, createUser, deleteUser, resetPwd } from '@/api/adminuser'

export default {
  name: 'CreateUser',
  components: {
    UploadImage,
    SelectHospital
  },
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this)
    }
  },
  created () {
    this.$on('create_user_ok', () => {
    })
  },

  methods: {

    handleSubmit () {
      const _this = this
      console.log(this)
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            user_name: values.user_name,
            user_nickname: values.user_nickname,
            user_mobile: values.user_mobile,
            user_qq: values.user_qq,
            user_mail: values.user_mail,
            user_comments: values.user_comments,
            role_id: values.role_id
          }
          createUser(params).then(res => {
            _this.$message.success(res.msg + ',该用户的初试密码为“123456”')

            this.form.resetFields()
          }).catch((err) => {
            _this.$message.error('创建失败')
          })
        }
      })
    }
  }
}
</script>
